//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { messageCateApi } from '@/api/setting';
export default {
  name: 'FormBox',
  data: function data() {
    return {
      tableFrom: {
        types: '',
        name: ''
      },
      types: [],
      options: []
    };
  },
  mounted: function mounted() {
    this.getMessageCate();
  },
  methods: {
    selectPeriod: function selectPeriod() {
      this.confirmData();
    },
    getMessageCate: function getMessageCate() {
      var _this = this;
      messageCateApi().then(function (res) {
        _this.options = res.data;
      });
    },
    handleTypes: function handleTypes(e) {
      if (e.length === 0) {
        this.tableFrom.types = '';
      } else {
        this.tableFrom.types = e[e.length - 1];
      }
      this.confirmData();
    },
    // 重置
    reset: function reset() {
      this.tableFrom = {
        types: '',
        name: ''
      };
      this.types = [];
      this.confirmData();
    },
    // 确认
    handleConfirm: function handleConfirm() {
      this.confirmData();
    },
    confirmData: function confirmData() {
      this.$emit('confirmData', this.tableFrom);
    }
  }
};